import { render, staticRenderFns } from "./CurriculumVitaeLearning.vue?vue&type=template&id=352ef7ea&"
import script from "./CurriculumVitaeLearning.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeLearning.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeLearning.vue?vue&type=style&index=0&id=352ef7ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports